// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternPillCluster_root__WSfCC","swipe":"PatternPillCluster_swipe__FkdGH","noWrap":"PatternPillCluster_noWrap__1tbmn","rowGap":"PatternPillCluster_rowGap__6s3MF"};